module.exports = __webpack_public_path__ + "d664201f/img/mini-logo.18817ee5.svg";